<template>
  <img
    :src="$publicPath + 'img/header-nav-icons/messages.svg'"
    width="20"
    class="message-marker"
  >
</template>

<script>
export default {
  computed: {
    hasUnread () {
      return this.$store.getters['campaignsMessages/hasUnread']
    }
  }
}
</script>

<style lang="scss" scoped>
.message-marker {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 20px;
    height: auto;
    display: inline-block;
    animation: pulse 1s infinite;
}
@keyframes pulse {
    0% {
        transform: scale(0.75);
    }

    70% {
        transform: scale(1);
    }

    100% {
        transform: scale(0.75);
    }
}
</style>
